import { Icon, IconComponent, l } from '@manychat/manyui'
import { MakeTranslateReturnValue } from '@manychat/manyui/src/utils/localization/format'

import { GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

export const MAX_GOALS_NUMBER = 3

export const goalTypes: Record<
  GoalType,
  {
    name: MakeTranslateReturnValue
    GoalIcon: IconComponent
    type: GoalType
    descriptionTitle: MakeTranslateReturnValue
    descriptionText: MakeTranslateReturnValue
    publishCallToAction: MakeTranslateReturnValue
    publishLiveText: MakeTranslateReturnValue
    successPublishingAlert: MakeTranslateReturnValue
    goLiveText: MakeTranslateReturnValue
  }
> = {
  [GoalType.LEAD_GEN]: {
    name: l.makeTranslate('Share the link'),
    GoalIcon: Icon.Link,
    type: GoalType.LEAD_GEN,
    descriptionTitle: l.makeTranslate(
      'AI will share your link<l10n context="when triggered after Always-on Answers or Positive Comment Responder."/>',
    ),
    descriptionText: l.makeTranslate(
      '<l10n context="AI will share your link"/>when triggered after Always-on Answers or Positive Comment Responder.',
    ),
    publishCallToAction: l.makeTranslate(
      '<l10n context="Let’s go live"/>And get those clicks coming in!',
    ),
    publishLiveText: l.makeTranslate('Your link is being shared in DMs when triggered.'),
    successPublishingAlert: l.makeTranslate(
      'Your goal is live! AI will start sending your message to get more link visits',
    ),
    goLiveText: l.makeTranslate('Let’s go live!'),
  },
  [GoalType.GROW_FOLLOWERS]: {
    name: l.makeTranslate('Get more followers'),
    GoalIcon: Icon.Community,
    type: GoalType.GROW_FOLLOWERS,
    descriptionTitle: l.makeTranslate(
      'AI will ask them to follow you<l10n context="If someone isn\'t following you and AI answers their question or replies to their nice comment, they\'ll get a DM with a follow request."/>',
    ),
    descriptionText: l.makeTranslate(
      '<l10n context="AI will ask them to follow you"/>If someone isn\'t following you and AI answers their question or replies to their nice comment, they\'ll get a DM with a follow request.',
    ),
    publishCallToAction: l.makeTranslate('<l10n context="Let’s go live"/>And grow followers!'),
    publishLiveText: l.makeTranslate('Your follow message is being sent in DMs when triggered.'),
    successPublishingAlert: l.makeTranslate(
      'Your goal is live! AI will start sending your message to grow followers',
    ),
    goLiveText: l.makeTranslate('Let’s go live!'),
  },
  [GoalType.LEAD_QUAL]: {
    name: l.makeTranslate('Qualify leads'),
    GoalIcon: Icon.PublicChangelog,
    type: GoalType.LEAD_QUAL,
    descriptionTitle: l.makeTranslate(
      'AI will collect information in a DM<l10n context="when triggered after Always-on Answers or Positive Comment Responder."/>',
    ),
    descriptionText: l.makeTranslate(
      '<l10n context="AI will collect information in a DM"/>when triggered after Always-on Answers or Positive Comment Responder.',
    ),
    publishCallToAction: l.makeTranslate(
      '<l10n context="Let’s go live"/>And start collecting info!',
    ),
    publishLiveText: l.makeTranslate('Your follow message is being sent in DMs when triggered.'),
    successPublishingAlert: l.makeTranslate(
      'Your goal is live! AI will start sending your message to qualify leads.',
    ),
    goLiveText: l.makeTranslate('Preview and go live!'),
  },
}
